import {
  createRootRoute,
  createRoute,
  createRouter,
  Outlet,
} from '@tanstack/react-router';
import { Layout } from '@/components/Layout';
import { HomePage } from '@/pages/HomePage';
import { WeatherPage } from '@/pages/WeatherPage';
import { WeatherCoordinatesPage } from '@/pages/WeatherCoordinatesPage';
import { AlertsPage } from '@/pages/AlertsPage';
import { RegionPage } from '@/pages/RegionPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { PrivacyPage } from '@/pages/PrivacyPage';
import { TermsPage } from '@/pages/TermsPage';

// Root route with layout
const rootRoute = createRootRoute({
  component: () => (
    <Layout>
      <Outlet />
    </Layout>
  ),
  notFoundComponent: NotFoundPage,
});

// Home page
const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: HomePage,
});

// Weather page for a location
const weatherRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/weather/$locationId',
  component: WeatherPage,
});

// Weather page for coordinates (current location)
const weatherCoordinatesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/weather/coordinates',
  component: WeatherCoordinatesPage,
  validateSearch: (search: Record<string, unknown>) => ({
    lat: search.lat as string,
    lon: search.lon as string,
    city: search.city as string | undefined,
  }),
});

// Alerts page
const alertsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/alerts',
  component: AlertsPage,
});

// Region page
const regionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/region/$regionId',
  component: RegionPage,
});

// Privacy page
const privacyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/privacy',
  component: PrivacyPage,
});

// Terms page
const termsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/terms',
  component: TermsPage,
});

// Route tree
const routeTree = rootRoute.addChildren([indexRoute, weatherCoordinatesRoute, weatherRoute, alertsRoute, regionRoute, privacyRoute, termsRoute]);

// Create router
export const router = createRouter({ routeTree });

// Type declarations for router
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
